export default {
  hello: 'Bonjour!',
  back: 'Revenir à la liste',
  card: {
    label: 'Voir l\'activité en détails',
    infos: 'Informations sur l\'activité',
    favorite: 'Ajouter aux favoris',
    new: 'Nouvelle activité',
    from: 'A partir de ',
  },
  list: {
    label: 'Liste des activités',
    total: 'activités trouvées',
    load: 'Voir plus',
  },
  menu: {
    sorting: 'Trier par',
    filters: 'Filtres',
    relevance: 'Pertinence',
    price_asc: 'Prix (croissant)',
    price_desc: 'Prix (décroissant)',
    ranking: 'Evaluation / Note',
    place: 'Lieu',
    moment: 'Moment de la journée',
    duration: 'Durée',
    price: 'Prix',
    min: 'Prix € min.',
    max: 'Prix € max.',
    range: 'Disponible ',
    day: 'sur la journée',
    from: 'de',
    to: 'à',
    start: 'Durée min (h.):',
    end: 'Durée max (h.):',
  },
  search: {
    label: 'Recherche d\'activité',
    button: 'Rechercher',
    cancel_button: 'Tout effacer',
    placeholder: 'Rechercher',
    themes: 'Thèmes',
    activities: 'Activités',
    default: 'Commencer ma recherche',
    dates: 'Toutes dates',
    togglethemes: 'Voir les thèmes',
    // toggleactivities: "Voir les activités",
    togglecalendar: 'Sélectionner une période',
  },
  timeRange: {
    morning: 'En matinée (de 8h à midi)',
    afternoon: 'L\'après-midi (de midi à 17h)',
    evening: 'En soirée (de 17h à minuit)',
  },
  activities: {
    label: 'Liste des activités',
    left: 'Déplacer vers la gauche',
    right: 'Déplacer vers la droite',
  },
  editor: {
    selection: {
      manual: 'Sélection manuelle',
      auto: 'Sélection automatique',
      validate: 'Valider ma sélection',
      configure: 'Configurer la sélection',
      summary: 'Récapitulatif de la sélection',
      from_any_provider: 'de n\'importe quel prestataires',
    },
    searchEngine: {
      title: 'Widget YouBOOK Moteur de recherche',
    },
    title: 'Widget YouBOOK Mise en avant',
    create_widget: 'Créer le widget',
    delete_all: 'Tout effacer',
    add_product: 'Ajouter une activité',
    search_product: 'Rechercher un produit ...',
    do_manual_selection: 'Effectuer votre sélection manuelle',
    show_results: 'Afficher les résultats',
  },
  filters: {
    places: 'Lieu | Lieux',
    types: 'Type | Types',
    themes: 'Thème | Thèmes',
    audiences: 'Public | Publics',
    internals: 'Interne | Internes',
  },
  providers: {
    regiondo: 'Regiondo',
    welogin: 'WeLogin',
    guidap: 'Guidap',
    bokun: 'Bókun',
  },
  aria: {
    details: 'Détails de l\'offre',
    presentation: 'présentation de l\'activité',
    cta: 'réserver maintenant cette activité',
    cta_action: 'réserver une date',
    provider_logo: 'logo du prestataire',
    highlights: 'point forts de l\'activité',
    provider_book: 'réservation avec le prestataire',
    crosselling: 'autres activités conseillées',
  },
  cta: {
    share: 'Partager',
    price: 'À partir de',
    book: 'Réserver',
    book_a_date: 'Réserver une date',
    add_to_favorites: 'Ajouter aux favoris',
    retry: 'Réessayer',
    next_session: 'Prochaine disponibilité',
  },
  popover: {
    share: 'Partager cette activité:',
    go_to: 'Comment vous y rendre ?',
  },
  content: {
    reviews: 'avis',
    recommended_by: 'Recommandé par',
    available_soon: 'Activité bientôt disponible',
    available_today: 'Disponible aujourd\'hui',
    available_tomorrow: 'Disponible dès demain',
    highlights: 'Points forts',
    options: 'Choisissez vos dates, vos options ...',
    fee: 'Zéro frais, même prix qu\'en direct',
    experience: 'Votre expérience',
    included: 'Inclus',
    not_included: 'Non inclus',
    powered_by: 'Proposé par ',
    conditions: 'Conditions',
    essentials: 'Essentiels',
    groups: 'Participants',
    other: 'Autres',
    meeting_point: 'Lieu de rendez-vous',
    go_to: 'M\'y rendre',
    address: 'Adresse :',
    how_to_go: 'Comment s\'y rendre :',
    transport: 'Transport :',
    book_peacefully: 'Réserver en toute sérénité avec notre partenaire',
    complementary_infos: 'Infos complémentaires',
    locality: 'Localité',
    other_activities: 'Vous aimerez aussi',
    eco_friendly: {
      title: 'Ils s\'engagent',
      description: 'En choisissant l\'activité bas-carbone \« {activityName} \», vous limitez considérablement votre impact environnemental.',
      detail: 'Une activité bas carbone n\'émet pas ou très peu de CO2 provenant des énergies fossiles.',
    },
    more: 'Voir plus',
    less: 'Voir moins',
  },
  error: {
    data_unavailable: 'Les informations sur cette activité sont indisponibles pour le moment.',
  },
};
